import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {
  createBrowserRouter,
  createHashRouter,
  HashRouter,
  Route,
  RouterProvider,
  Routes,
} from "react-router-dom";
import Error from './Error';
import Blog from './Blog';
import Article from './Article';
import ConstructionPage from './ConstructionPage';
import ResumePdf from './resources/resume-shreyas.pdf';
import Resume from './Resume';

const router = createHashRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <Error />,
  },
  {
    path: "/blog",
    element: <Blog />,
    errorElement: <ConstructionPage />
  },
  {
    path: "/articles/:article",
    element: <Article />,
  },
  {
    path: '/travel',
    element: <ConstructionPage />,
  },
  {
    path: "/projects",
    element: <ConstructionPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    {/* <HashRouter>
      <Routes>
        <Route exact path="/personal-site" element={ <Home /> } />
        <Route exact path="/#/" element={ <Home />} />
        <Route exact path="/personal-site/projects/" element={ <ConstructionPage /> } />
        <Route exact path="/personal-site/blog/" element={ Blog } />
      </Routes>
    </HashRouter> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
